<template>
  <div></div>
</template>

<script>
import logger from "@/utils/logger";
import { getOrderDetailLink } from "@/api/order";

const name = "OrderDetailRedirect";
const log = logger(name);

export default {
  name,
  async created() {
    const orderNumber = this.$route.params.orderNumber;
    if (!orderNumber) {
      log.info("No order number found");
      return this.$router.replace("/");
    }

    log.info(`Redirect order ${orderNumber} to detail page`);
    const redirectUrl = await getOrderDetailLink(orderNumber);
    log.info(`Redirecting to ${redirectUrl}`);
    window.location.href = redirectUrl;
  },
};
</script>

<style scoped></style>
